import { c as _c } from "react/compiler-runtime";
import Svg, { type SvgProps } from '../../Svg';
const ClockIcon = props => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <path d="M6 4.24219V6L8.19703 8.1975M1.07812 6C1.07813 7.30536 1.59668 8.55726 2.51971 9.48029C3.44274 10.4033 4.69464 10.9219 6 10.9219C7.30536 10.9219 8.55726 10.4033 9.48029 9.48029C10.4033 8.55726 10.9219 7.30536 10.9219 6C10.9219 4.69464 10.4033 3.44274 9.48029 2.51971C8.55726 1.59668 7.30536 1.07813 6 1.07812C4.69464 1.07813 3.44274 1.59668 2.51971 2.51971C1.59668 3.44274 1.07813 4.69464 1.07812 6Z" className="stroke-current" strokeLinecap="round" strokeLinejoin="round" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <Svg width={12} height={12} {...props}>{t0}</Svg>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export default ClockIcon;